import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, CardTitle, Col, Table } from "reactstrap";

const ReportTable = (props) => {
    const [years, setYear] = useState([])
    const [locations, setLocations] = useState([]);
    const [dataset, setDataset] = useState(null);
    const data = props.data

    const filldata = async () => {
        const years = []
        const temp = [];

        data.map(d => temp.push(...d.values));
        const locationCodes = [...new Set(temp.map(item => item.locationCode))];
        data.sort((a, b) => a.year - b.year).map(d => years.push(d.year));

        setDataset(temp)
        setLocations(locationCodes)
        setYear(years)
        console.log(temp);
    }

    const getData = (year, location)  => {
        const item = dataset.find(d => +d.year === year && d.locationCode === location);
        return item ? item.value : '-';
    }

    useEffect(() => {
        filldata()
    }, [data])

    return (
        <Col xs={12} sm={12}>
            <Card>
                <CardHeader>
                    <CardTitle className="text-right" tag="h4">{props.title}</CardTitle>
                </CardHeader>
                <CardBody>
                    <Table className="tablesorter text-center" >
                        <thead className="text-primary">
                            <tr>
                                <th className="text-right">استان</th>
                                {years && years.map(y => (
                                    <th className="text-center">{y}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {dataset && locations && locations.sort().map(loc => {
                                
                                return (
                                    <tr>
                                        <td className="text-right">{dataset.find(f=>f.locationCode === loc).locationName}</td>
                                        {years.map(y => (<td>{getData(y, loc)}</td>))}

                                    </tr>
                                )
                            })
                            }


                        </tbody>
                    </Table>
                </CardBody>
            </Card>

        </Col>
    )
};

export default ReportTable;